import React from 'react';
import PropTypes from 'prop-types';

import StatusBadge from '../statusBadge.component';
import { getRunStatusMessage, blankLabel } from '../../dashboard/connectionMonitorPage/constants';

export const RunStatusCellRenderer = ({ value }) => {
  const badgeMessage = getRunStatusMessage(value);

  return (
    <StatusBadge className="table-badge" value={badgeMessage} />
  );
};

RunStatusCellRenderer.propTypes = { value: PropTypes.number };

export const RunStatusFilterCellRenderer = ({ value }) => {
  const badgeMessage = value === null ? blankLabel : getRunStatusMessage(value);

  return badgeMessage;
};

RunStatusFilterCellRenderer.propTypes = { value: PropTypes.number };

